import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer style7">
        <div className="container">
          <div className="container-wapper">
            <div className="row">
              <div className="box-footer col-xs-12 col-sm-4 col-md-4 col-lg-4 hidden-sm hidden-md hidden-lg">
                <div className="ysera-newsletter style1">
                  <div className="newsletter-head">
                    <h3 className="title">Newsletter</h3>
                  </div>
                  <div className="newsletter-form-wrap">
                    <div className="list">
                      Sign up for our free video course and <br /> urban garden
                      inspiration
                    </div>
                    <input
                      type="email"
                      className="input-text email email-newsletter"
                      placeholder="Your email letter"
                    />
                    <button className="button btn-submit submit-newsletter">
                      SUBSCRIBE
                    </button>
                  </div>
                </div>
              </div>
              <div className="box-footer col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="ysera-custommenu default">
                  <h2 className="widgettitle fs-2">Quick Menu</h2>
                  <ul className="menu">
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark fs-3'>Who Are We ?</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="/contact-us" className='text-decoration-none text-dark fs-4'>Contact Us</Link>
                    </li>
                    {/* <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Bracelets</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>By Metal</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Earrings</Link>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="box-footer col-xs-12 col-sm-4 col-md-4 col-lg-4 hidden-xs">
                <div className="ysera-newsletter style1">
                  <div className="newsletter-head">
                    <h3 className="title fs-2">Newsletter</h3>
                  </div>
                  <div className="newsletter-form-wrap">
                    <div className="list fs-3">
                      Sign up for our free video course and <br /> urban garden
                      inspiration
                    </div>
                    <input
                      type="email"
                      className="input-text email email-newsletter"
                      placeholder="Your email letter"
                    />
                    <button className="button btn-submit submit-newsletter">
                      SUBSCRIBE
                    </button>
                  </div>
                </div>
              </div>
              <div className="box-footer col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="ysera-custommenu default">
                  <h2 className="widgettitle fs-2">Information</h2>
                  <ul className="menu fs-5">
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>FAQs</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Track Order</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Delivery</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Contact Us</Link>
                    </li>
                    <li className="menu-item">
                      <Link to="#" className='text-decoration-none text-dark'>Return</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-end">
              <div className="row">
                <div className="col-sm-12 col-xs-12">
                  <div className="ysera-socials">
                    <ul className="socials">
                      <li>
                        <Link to="#" className="social-item" target="_blank">
                          <i className="icon ph ph-facebook-logo"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-item" target="_blank">
                          <i className="icon ph ph-twitter-logo"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-item" target="_blank">
                          <i className="icon ph ph-instagram-logo"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="coppyright">
                    Copyright © 2025
                    <Link to="#"> Unique Jewellers</Link>. All rights reserved
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
